import type { FC } from 'react';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@rivallapp/volosports-components';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { graphql, type FragmentOf } from 'graphql-schema';
import styles from './styles.module.scss';
import { ColorIndicator, Tooltip } from '../../../../../../components';

const cx = classNames.bind(styles);

export const DROP_IN_ROSTER_GAME_FRAGMENT = graphql(`
  fragment DropInRosterGame on games @_unmask {
    _id
    teams {
      _id
      teamByTeam {
        _id
        name
        color_hex
        color_name
      }
      rsvps_aggregate(where: { response: { _eq: YES } }) {
        aggregate {
          count
        }
      }
      drop_in_rsvps_aggregate: rsvps_aggregate(
        where: { response: { _eq: YES }, is_drop_in: { _eq: true } }
      ) {
        aggregate {
          count
        }
      }
    }
  }
`);

type Props = {
  game: FragmentOf<typeof DROP_IN_ROSTER_GAME_FRAGMENT>;
  onClick: () => void;
  active?: boolean;
};

const DropInGamesRow: FC<Props> = ({
  game: {
    teams: [teamOne, teamTwo],
  },
  onClick,
  active,
}) => {
  const teamOneRsvpCount = teamOne?.rsvps_aggregate.aggregate?.count ?? 0;
  const teamTwoRsvpCount = teamTwo?.rsvps_aggregate.aggregate?.count ?? 0;
  const teamOneDropInRsvpCount = teamOne?.drop_in_rsvps_aggregate.aggregate?.count ?? 0;
  const teamTwoDropInRsvpCount = teamTwo?.drop_in_rsvps_aggregate.aggregate?.count ?? 0;

  const teamOneRsvpStr = `${teamOneRsvpCount}${
    teamOneDropInRsvpCount ? ` (${teamOneDropInRsvpCount} drop-ins)` : ''
  }`;
  const teamTwoRsvpStr = `${teamTwoRsvpCount}${
    teamTwoDropInRsvpCount ? ` (${teamTwoDropInRsvpCount} drop-ins)` : ''
  }`;

  return (
    <div className={cx('dropinRowContainer')}>
      <button className={cx('dropinGamesRow', active && 'active')} onClick={onClick} type="button">
        <div className={cx('dropinGamesRowCol')}>
          {teamOne ? (
            <p className={cx('noWrap')} data-for="team-one-name" data-tip={teamOne.teamByTeam.name}>
              <ColorIndicator
                color={teamOne.teamByTeam.color_hex || teamOne.teamByTeam.color_name}
                size="19px"
              />
              {teamOne.teamByTeam.name}
            </p>
          ) : (
            <p className={cx('noWrap')}>Unassigned</p>
          )}
          <Tooltip id="team-one-name" />
          {teamTwo ? (
            <p className={cx('noWrap')} data-for="team-two-name" data-tip={teamTwo.teamByTeam.name}>
              <ColorIndicator
                color={teamTwo.teamByTeam.color_hex || teamTwo.teamByTeam.color_name}
                size="19px"
              />
              {teamTwo.teamByTeam.name}
            </p>
          ) : (
            <p className={cx('noWrap')}>Unassigned</p>
          )}
          <Tooltip id="team-two-name" />
        </div>
        <div className={cx('dropinGamesRowCol')}>
          <p className={cx('noWrap')}>
            <FontAwesomeIcon paddingTop={2} icon={faCheck} colorScheme="success" size="md" />
            {teamOneRsvpStr}
          </p>
          <p className={cx('noWrap')}>
            <FontAwesomeIcon paddingTop={2} icon={faCheck} colorScheme="success" size="md" />
            {teamTwoRsvpStr}
          </p>
        </div>
      </button>
      {active && <div className={cx('rowArrow')} />}
    </div>
  );
};

export default DropInGamesRow;
